import type { SpeedDialDesignTokens, SpeedDialTokenSections } from '@openng/optimus-ui-themes/types/speeddial';

export const root: SpeedDialTokenSections.Root = {
    gap: '0.5rem',
    transitionDuration: '{transition.duration}'
};

export default {
    root
} satisfies SpeedDialDesignTokens;
